import { useRouter } from 'next/router';
import SigninLayout from '../../components/scenes/SigninScene/SigninLayout';

const SignIn = () => {
  const router = useRouter();

  // Use new signin layout for signin context
  return (
    <SigninLayout
      default_error={router.query.error as string}
      redirect={router.query.redirect as string}
    />
  );
};

SignIn.configs = {
  title: 'Sign in',
  desc: 'Create or login with your Hookdeck account',
};

export default SignIn;
